<template>
  <HeadlessTransitionRoot as="template" :show="showModal">
    <HeadlessDialog
      as="div"
      class="relative z-10"
      @close="$emit('update:showModal', false)"
    >
      <HeadlessTransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <HeadlessTransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <HeadlessDialogPanel
              class="relative transform rounded-lg bg-white pb-10 pt-0 text-left shadow-xl transition-all sm:my-8 sm:w-full
                overflow-hidden border border-Primary-800
              "
              :class="sizeTailwindClass"
            >
              <div>
                <div class="bg-Primary-200 py-2 px-2.5 text-xs font-semibold uppercase"><slot name="heading"></slot></div>
                <div class="text-center px-12">
                  <div class="flex items-start justify-between pt-14">
                    <HeadlessDialogTitle
                      as="h3"
                      class="text-4xl text-black"
                    >
                      <slot name="title"> </slot>
                    </HeadlessDialogTitle>
                    <div class="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        class="rounded-md text-black hover:ring-2 focus:outline-none border-none hover:border-none"
                        @click="$emit('update:showModal', false)"
                      >
                        <span class="sr-only">Close panel</span>
                        <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>

                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      <slot name="content"> </slot>
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="showButtons"
                class="mt-5 sm:mt-6 sm:flex sm:justify-around"
              >
                <slot name="buttons">
                  <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="$emit('update:showModal', false)"
                    ref="cancelButtonRef"
                  >
                    OK
                  </button>
                </slot>
              </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup>
// import { useViewModesOptionsStore } from "@/stores/viewModesOptions";
// const modesOptionsStore = useViewModesOptionsStore();
import { XMarkIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  sizeTailwindClass: {
    type: String,
    default: "sm:max-w-lg",
  },
  showButtons: {
    type: Boolean,
    default: true,
  },
  showModal: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:showModal"]);
</script>

<style lang="scss" scoped></style>
